import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { message } from 'antd'

import { constants } from '../../modules/leadFunctions/leadContractActions'
import * as api from '../../api/lead/contracts'
import { fetchLeadDetails } from '../leadDetails'

function* leadContractRefresh(action) {
  try {
    const payload = yield call(api.getLeadContract, action.leadId)
    yield put({ type: constants.LEAD_CONTRACTS_REFRESH.SUCCESS, payload })
    action.next && action.next(null, payload)
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.LEAD_CONTRACTS_REFRESH.FAILED,
      message: e.message || e
    })
  }
}

function* watchLeadContract() {
  yield takeLatest(constants.LEAD_CONTRACTS_REFRESH.ACTION, leadContractRefresh)
}

function* sagaCreateLeadContract(action) {
  try {
    const payload = {
      lead_id: action.leadId,
      proposal_id: action.content.proposal_id,
      contract_template_id: action.content.contract_template_id,
      name: action.content.name,
      description: action.content.description,
      overview: action.content.overview,
      work_by_others: action.content.work_by_others,
      terms: action.content.terms,
      header: action.content.header,
      footer: action.content.footer,
      created_by_id: action.userId,
      updated_by_id: action.userId,
      paymentSchedule: action.paymentSchedule
    }
    yield call(api.createLeadContract, payload)
    yield put({ type: constants.LEAD_CONTRACT_CREATE.SUCCESS, payload })
    yield call(leadContractRefresh, { leadId: action.leadId })
    yield call(fetchLeadDetails, { leadId: action.leadId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.LEAD_CONTRACT_CREATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchCreateLeadContract() {
  yield takeLatest(constants.LEAD_CONTRACT_CREATE.ACTION, sagaCreateLeadContract)
}

function* sagaUpdateLeadContract(action) {
  try {
    const payload = {
      lead_id: action.leadId,
      contract_id: action.contractId,
      content: action.content,
      updated_by_id: action.userId,
      paymentSchedule: action.paymentSchedule
    }
    yield call(api.updateLeadContract, payload)
    yield put({ type: constants.LEAD_CONTRACT_UPDATE.SUCCESS, payload })
    yield call(leadContractRefresh, { leadId: action.leadId })
    yield call(fetchLeadDetails, { leadId: action.leadId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.LEAD_CONTRACT_UPDATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateLeadContract() {
  yield takeLatest(constants.LEAD_CONTRACT_UPDATE.ACTION, sagaUpdateLeadContract)
}

function* sagaDeleteLeadContract(action) {
  try {
    const payload = {
      contract_id: action.contractId,
      leadId: action.leadId
    }
    yield call(api.deleteLeadContract, payload)
    yield put({ type: constants.LEAD_CONTRACT_DELETE.SUCCESS, payload })
    yield call(leadContractRefresh, { leadId: action.leadId })
    yield call(fetchLeadDetails, { leadId: action.leadId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.LEAD_CONTRACT_DELETE.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteLeadContract() {
  yield takeLatest(constants.LEAD_CONTRACT_DELETE.ACTION, sagaDeleteLeadContract)
}

// ATTACHMENT SAGAS
function* uploadAttachments(action) {
  try {
    const payload = {
      formData: action.formData,
      contractId: action.contractId
    }
    message.info('Uploading Signed Contract')
    yield call(api.uploadAttachments, payload)
    yield put({ type: constants.UPLOAD_CONTRACT_ATTACHMENT.SUCCESS, payload })
    message.success('Signed Contract Uploaded with success')
    yield call(leadContractRefresh, { leadId: action.leadId })
  } catch (e) {
    message.error('Problems uploading Signed Contract, please try again')
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.UPLOAD_CONTRACT_ATTACHMENT.FAILED,
      message: e.message || e
    })
  }
}

function* watchUploadAttachments() {
  yield takeLatest(constants.UPLOAD_CONTRACT_ATTACHMENT.ACTION, uploadAttachments)
}

function* getAttachments(action) {
  try {
    const payload = yield call(api.getAttachments, action.contractId)
    yield put({ type: constants.GET_CONTRACT_ATTACHMENTS.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_CONTRACT_ATTACHMENTS.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetAttachments() {
  yield takeLatest(constants.GET_CONTRACT_ATTACHMENTS.ACTION, getAttachments)
}

function* updateAttachmentDescription(action) {
  try {
    const payload = {
      attachmentId: action.attachmentId,
      created_by_id: action.userId,
      updated_by_id: action.userId,
      user_id: 1,
      description: action.description
    }
    yield call(api.updateAttachmentDescription, payload)
    yield put({ type: constants.UPDATE_CONTRACT_ATTACHMENT_DESCRIPTION.SUCCESS, payload })
    yield call(getAttachments, { contractId: action.currentId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.UPDATE_CONTRACT_ATTACHMENT_DESCRIPTION.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateAttachmentDescription() {
  yield takeLatest(
    constants.UPDATE_CONTRACT_ATTACHMENT_DESCRIPTION.ACTION,
    updateAttachmentDescription
  )
}

function* deleteAttachment(action) {
  try {
    const payload = {
      attachmentId: action.attachmentId,
      contractId: action.contractId
    }

    yield call(api.deleteAttachment, payload)
    yield put({ type: constants.DELETE_CONTRACT_ATTACHMENT.SUCCESS, payload })
    yield call(getAttachments, { contractId: action.contractId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.DELETE_CONTRACT_ATTACHMENT.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteAttachments() {
  yield takeLatest(constants.DELETE_CONTRACT_ATTACHMENT.ACTION, deleteAttachment)
}

function* sagaSetContractStatus(action) {
  try {
    const payload = {
      contract_id: action.contractId,
      status: action.status,
      lead_id: action.leadId
    }
    yield call(api.setLeadContractStatus, payload)
    yield put({ type: constants.SET_CONTRACT_STATUS.SUCCESS, payload })
    yield call(leadContractRefresh, { leadId: action.leadId })
    yield call(fetchLeadDetails, { leadId: action.leadId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.SET_CONTRACT_STATUS.FAILED,
      message: e.message || e
    })
  }
}

function* watchSetContractStatus() {
  yield takeLatest(constants.SET_CONTRACT_STATUS.ACTION, sagaSetContractStatus)
}

/**
 * Export the root saga by forking all available sagas.
 */
export function* rootSaga() {
  // add more sagas here
  yield all([
    fork(watchLeadContract),
    fork(watchCreateLeadContract),
    fork(watchUpdateLeadContract),
    fork(watchDeleteLeadContract),

    fork(watchUploadAttachments),
    fork(watchGetAttachments),
    fork(watchUpdateAttachmentDescription),
    fork(watchDeleteAttachments),

    fork(watchSetContractStatus)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/leadFunctions/leadContractSaga.js